// object lib
import getRawObjectId from './getRawId.lib.object';

const areSameObjectIds = (...ids) =>
  [...ids]
    .map((id) => getRawObjectId(id))
    .every((id) => id === getRawObjectId(ids?.[0]));

export default areSameObjectIds;
